import StartSim from './StartSim';

export default StartSim;